import { ESectionColor, Section } from '@web_opxp/components';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, Action } from 'redux';
import { CyclesSelectors } from '../../cycles';
import { IState } from '../../store/state';
import { AssessmentProgress, ProgressPageState } from '../AssessmentProgress';
import * as Selectors from '../selectors';
import { AssessmentActions } from '../slice';
import Question from './Question';

export default function CFQQuestionSection() {
  const workoutId = useSelector(Selectors.getWorkoutId);
  const cfqRelativeIndex = useSelector((state: IState) => CyclesSelectors.getCFQWorkoutRelativeIndex(state, workoutId));
  const sessionLength = useSelector(CyclesSelectors.getCFQSessionLength);
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  const questionNumber = cfqRelativeIndex + 1;
  const answerHandler = (answer: number) => {
    dispatch(AssessmentActions.answerCFQ(answer));
  };
  return (
    <>
      <Section color={ESectionColor.blue} className="cfq-question-section">
        <div className="cfq-question-container">
          <Question questionId={workoutId} onAnswer={answerHandler} />
        </div>
      </Section>
      <Section>
        <AssessmentProgress page={ProgressPageState.CFQSession} max={sessionLength} step={questionNumber} cfq={true} />
      </Section>
    </>
  );
}
